import HttpClient from "@api/clients/httpClient";
import { Filter } from "@api/models/HttpClientModels";
import UserAddress from "../models/UserAddress";

const config = {
    endpoint: "user-addresses",
};

export default class UserAddressService {
    httpClient: HttpClient;

    constructor() {
        this.httpClient = new HttpClient(config.endpoint, new Filter());
    }

    upsertAsync = async (userAddress: UserAddress) => {
        return await this.httpClient.putAsync<UserAddress>("", userAddress, "upsert");
    }
}